import {StringRepresentation} from '../types';

export function isVersionEqual(
  versionA: StringRepresentation,
  versionB: StringRepresentation
): boolean {
  return versionA === versionB;
}
